/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import "./Affilate.css";
import CustomDatePicker from "../../components/CustomDatePicker copy/CustomDatePicker";
import moment from "moment";
import { connectAffiliate } from "./Affiliate.connect";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";

const BettingProfitLoss = ({ actions }) => {
  const { id } = useParams();
  const [plData, setPlData] = useState(null);
  const [selectDays, setSelectdays] = useState(7);
  const today = new Date();
  const [startDate, setStartDate] = useState(
    new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - selectDays,
    ),
  );
  const [endDate, setEndDate] = useState(moment().toDate());

  const getAffSpecificUserSportWisePL = async () => {
    await actions
      .getAffSpecificUserSportWisePL({
        from_date: startDate,
        to_date: endDate,
        affiliated_user_id: id ?? "",
      })
      .then((res) => {
        setPlData(res?.data?.data?.response);
      })
      .catch((e) => toastr.error("", `${e}`));
  };

  useEffect(() => {
    getAffSpecificUserSportWisePL();
  }, [endDate]);

  const submit = () => {
    getAffSpecificUserSportWisePL();
  };

  return (
    <>
      <div className="flex shadow flex-col mb-3 rounded-lg w-full h-full transition-all ease-in-out duration-200">
        <h2 className="font-semibold mt-3">Betting Profit/Loss</h2>
        <CustomDatePicker
          setSelectdays={setSelectdays}
          selectDays={selectDays}
          today={today}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          handleSearch={submit}
        />
      </div>

      <div className="overflow-x-auto bg-white rounded-lg m-2 lg:m-0 lg:mt-3 shadow">
        <table className="table bg-bg_light ">
          <thead>
            <tr
              style={{
                background: "var(--color-bg-primary-aff)",
              }}
            >
              <th className="text-center py-2 px-1 text-white">EVENT</th>
              <th className="text-center py-2 px-1 text-white">P & L</th>
            </tr>
          </thead>
          <tbody>
            {plData?.length > 0 ? (
              plData?.map((item, index) => (
                <tr key={index} className="user_list_tr">
                  <td className="text-center">{item?.sport_name}</td>
                  <td
                    className={`text-center ${
                      item?.user_pl > 0 ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    {item?.user_pl}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2} className="text-center py-4">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default connectAffiliate()(BettingProfitLoss);
